// import {
//   setAuthenticated,
//   setLocalLogout,
// } from '../../features/loginSlice';
import { toast } from 'react-toastify';
import { loginRequest } from './AuthConf';
import { isAPIFailed, isAPISuccess } from './utilFunctions';
import { CLIENT_ID, REACT_APP_VAM_CONTEXT_AUTHORIZATION, REACT_APP_VAM_ENDPOINT, tokenClientSecret, tokenScope } from './urls';
import axios from 'axios';
import Cookies from "js-cookie";
 
export const callLogin = (e,instance) => {
  
  if (e){
    e.preventDefault();
    instance.loginRedirect(loginRequest).catch(() => {});
  }  
};
export const addListener = (instance,onSuccessfulLogin) => {
  instance.addEventCallback((event) => {
    if (
      event.eventType === 'msal:acquireTokenSuccess' ||
      event.eventType === 'msal:loginSuccess'
    ) {

      if (event?.payload?.account) {
        onSuccessfulLogin(event.payload);
      } else {
        callLogin(null, instance);
      }
    }
  });
};
export const getRequestData = (payload) => {
  const data = {
    employeeName: payload.account.name,
    email: payload.account.username,
    accessToken: payload.accessToken,
    accessExpiryTime: payload.expiresOn,
    resetToken: payload.idToken,
    resetExpiryTime: payload.extExpiresOn,
    mobile_device_token: null,
  };
  return data;
};
export const logoutWithTimer = (instance) => {
  setTimeout(() => {
    instance.logoutRedirect();
  }, 2000);
};
export const errorWithTimer = (message) => {
  setTimeout(() => {
    toast.error(message);
  }, 500);
};
export const validateLogin = (
  fulfilled,
  instance,
  dispatch
) => {
  if (isAPIFailed(fulfilled)) {
    toast.error(fulfilled.responseInformation.responseMessage);
    // setLocalLogout()
    errorWithTimer('Logout..., Please contact admin.');
    logoutWithTimer(instance);
  } else if (isAPISuccess(fulfilled)) {
    if (
      fulfilled?.result?.roleId 
    ) {
      toast.success(fulfilled.responseInformation.responseMessage);
    //     setAuthenticated({
    //       status: LOGIN_STATUS.AUTHENTICATED,
    //       user: fulfilled.result}
    //   );
    } else {
    //   dispatch(setLocalLogout());
      errorWithTimer(
        'You do have have access. Please contact admin. Logout....'
      );
      logoutWithTimer(instance);
    }
  }
};
 